function isDev() {
    return process.env.NODE_ENV === 'development'
}

function getAPIURL() {
    if (process.env.NODE_ENV === 'development') {
        return 'https://stage.cell.wine/apis'
    } else if (process.env.NODE_ENV === 'production') {
        return 'https://back-end.cell.wine/apis'
    }
}

module.exports = {
    API_URL: getAPIURL(),
    FIREBASE: require(isDev() ? './client-dev' : './client')
}